/**
 * 日期字符串
 */
export const format = function (obj, fmt) {
  if (!obj || !fmt) {
    return '';
  }

  var o = {
    'M+': obj.getMonth() + 1,
    // 月份
    'd+': obj.getDate(),
    // 日
    'H+': obj.getHours(),
    // 小时
    'm+': obj.getMinutes(),
    // 分
    's+': obj.getSeconds(),
    // 秒
    'q+': Math.floor((obj.getMonth() + 3) / 3),
    // 季度
    S: obj.getMilliseconds() // 毫秒

  };

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (obj.getFullYear() + '').substr(4 - RegExp.$1.length));
  }

  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }

  return fmt;
};